<template>
  <el-form-item
    :prop="field.key"
    :label="field.name || field.label"
  >
    <el-input
      v-if="[fieldType.TEXT, fieldType.TEXTAREA].includes(field.type)"
      v-model="form[field.key]"
      :type="field.type"
      :autosize="{ minRows: 4, maxRows: 4 }"
      :disabled="disabled"
      :size="size"
      placeholder="Nhập thông tin"
    />
    <el-input-number
      v-if="[fieldType.NUMBER].includes(field.type)"
      v-model="form[field.key]"
      :type="field.type"
      placeholder="Nhập thông tin"
      class="w-100"
      :min="field.form.min"
      :max="field.form.max"
      :disabled="disabled"
      :size="size"
    />
    <el-date-picker
      v-else-if="[fieldType.DATE, fieldType.DATETIME].includes(field.type)"
      v-model="form[field.key]"
      placeholder="Chọn ngày"
      class="w-100"
      :format="field.format | getElementDateFormat"
      :type="field.type"
      :disabled="disabled"
    />
    <ItemSelect
      v-else-if="
        [fieldType.SELECT, fieldType.MULTIPLE_SELECT].includes(field.type)
      "
      :form="form"
      :field="field"
      :disabled="disabled"
      class="w-100"
      :size="size"
    />
    <el-checkbox-group
      v-else-if="[fieldType.CHECKBOX].includes(field.type)"
      v-model="form[field.key]"
      class="w-100"
      :disabled="disabled"
    >
      <el-checkbox
        v-for="option in field.options.value"
        :key="option"
        :label="option"
      />
    </el-checkbox-group>
    <el-radio-group
      v-else-if="[fieldType.RATIO].includes(field.type)"
      v-model="form[field.key]"
      class="w-100"
      :disabled="disabled"
    >
      <el-radio
        v-for="option in field.options.value"
        :key="option"
        :label="option"
      />
    </el-radio-group>
    <ItemEditor
      v-else-if="[fieldType.HTML].includes(field.type)"
      :editor-key="field.key"
      :value="form[field.key]"
      :disabled="disabled"
      @change="(v) => (form[field.key] = v)"
    />
    <ItemFiles
      v-else-if="
        [
          fieldType.FILE_IMAGES,
          fieldType.FILE_VIDEOS,
          fieldType.FILE_AUDIOS,
          fieldType.FILE_OTHERS,
        ].includes(field.type) && filePermission.READ
      "
      :form="form"
      :field="field"
      :disabled="disabled"
      @change="(v) => (form[field.key] = v)"
    />
    <ItemLinkYoutube
      v-else-if="[fieldType.LINK_YOUTUBE].includes(field.type)"
      :form="form"
      :field="field"
      :disabled="disabled"
      @change="(v) => (form[field.key] = v)"
    />
    <ItemLink3ds
      v-else-if="[fieldType.LINK_3DS].includes(field.type)"
      :form="form"
      :field="field"
      :disabled="disabled"
      @change="(v) => (form[field.key] = v)"
    />
    <el-select
      v-else-if="[fieldType.MODULE].includes(field.type)"
      v-model="form[field.key]"
      :placeholder="`Chọn ${field.name}`"
      class="w-100"
      :disabled="disabled"
      :size="size || 'default'"
      clearable
      @change="(v) => (form[field.key] = v)"
    >
      <el-option
        v-for="(m, index) in modules || []"
        :key="index"
        :label="m.name"
        :value="m.key"
      />
    </el-select>
  </el-form-item>
</template>

<script>
import constants from "@/config/constants";
import ItemSelect from "@/components/items/Select";
import ItemEditor from "@/components/items/Editor";
import ItemFiles from "@/components/items/Files";
import ItemLink3ds from "@/components/items/Link3ds";
import ItemLinkYoutube from "@/components/items/LinkYoutube";

import { filePer } from "@/utils/permission";

export default {
  name: "FormItem",
  components: {
    ItemSelect,
    ItemEditor,
    ItemFiles,
    ItemLink3ds,
    ItemLinkYoutube,
  },
  props: {
    form: Object,
    field: Object,
    disabled: Boolean,
    size: String,
    modules: Array
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
      filePermission: filePer(),
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss">
</style>
